var slides = document.getElementsByClassName('expert-list-detail--item');
var anchors = document.getElementsByClassName('nav-icon');

var prevButton = document.getElementById('travel-experts-top-safaris-prev');
var nextButton = document.getElementById('travel-experts-top-safaris-next');

var slidesLength = slides.length;
var anchorsLength = anchors.length;

var slideIndex = '';

if (slidesLength !== 0) {
    for (let i = 0; i < anchorsLength; i++) {
        anchors[i].addEventListener('click', function() {
            for (var o = 0; o < anchorsLength; o++) {
                anchors[o].classList.remove('active');
            }
            this.classList.add('active');
            for (var x = 0; x < slidesLength; x++) {
                slides[x].classList.remove('active');
            }
            slides[i].classList.add('active');
            slideIndex = i + 1;
        })
    }
}

if (prevButton) {
    prevButton.addEventListener('click', function() {
        showDivs(slideIndex += -1);
    });
}

if (nextButton) {
    nextButton.addEventListener('click', function() {
        showDivs(slideIndex += 1);
    });
}

function showDivs(n) {
    var i;
    if (n > slides.length) {
        slideIndex = 1
    }

    if (n < 1) {
        slideIndex = slides.length;
    } ;

    for (i = 0; i < slides.length; i++) {
      slides[i].classList.remove('active');
      anchors[i].classList.remove('active');
    }
    slides[slideIndex-1].classList.add('active');
    anchors[slideIndex-1].classList.add('active');
  }

  //Accordions

var accs = document.getElementsByClassName('expert-list-detail--item-title');
var o;
var oo;

for (o = 0; o < accs.length; o++) {
  accs[0].classList.add('active');
  var panel = accs[0].nextElementSibling;
  panel.style.maxHeight = panel.scrollHeight + "px";
  accs[o].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });

  var readMore = document.getElementsByClassName('show_the_hidden_text');

  for (oo = 0; oo < readMore.length; oo++) {
    readMore[oo].addEventListener("click", function() {
        var panel = this.closest('.expert-list-detail--item');
        if (panel.style.maxHeight) {
            panel.style.maxHeight = '100%'
        }
      });
  }
}